import React from 'react';
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Paper,
  styled,
  useTheme,
} from '@mui/material';

const PaymentMethodRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(0),
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
}));

const MethodInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const MethodIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: '50%',
  color: theme.palette.primary.main,
}));

interface PaymentMethod {
  id: string;
  name: string;
  icon: React.ReactNode;
}

interface PaymentMethodSelectionProps {
  onMethodSelect: (methodId: string) => void;
  selectedMethod: string;
}

const PaymentMethodSelection: React.FC<PaymentMethodSelectionProps> = ({
  onMethodSelect,
  selectedMethod,
}) => {
  const theme = useTheme();

  const paymentMethods: PaymentMethod[] = [
    {
      id: 'stripe',
      name: 'Stripe',
      icon: <Typography sx={{ fontWeight: 'bold', fontSize: 18, color: theme.palette.primary.main }}>S</Typography>,
    },
  ];

  return (
    <Box sx={{ fontFamily: "'Libre Franklin', sans-serif" }}>
      <Typography
        variant="h6"
        sx={{
          mb: 4,
          color: '#FFFFFF',
          fontFamily: "'Libre Franklin', sans-serif",
        }}
      >
        Select the payment method
      </Typography>
      
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          value={selectedMethod}
          onChange={(e) => onMethodSelect(e.target.value)}
        >
          {paymentMethods.map((method) => (
            <Paper
              key={method.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                p: 2,
                borderRadius: 2,
              }}
            >
              <PaymentMethodRow onClick={() => onMethodSelect(method.id)}>
                <MethodInfo>
                  <MethodIcon>
                    {method.icon}
                  </MethodIcon>
                  <Typography
                    variant="body1"
                    sx={{ fontFamily: "'Libre Franklin', sans-serif" }}
                  >
                    {method.name}
                  </Typography>
                </MethodInfo>

                <FormControlLabel
                  value={method.id}
                  control={<Radio />}
                  label=""
                  sx={{
                    margin: 0,
                    '& .MuiFormControlLabel-label': {
                      display: 'none',
                    },
                  }}
                />
              </PaymentMethodRow>
            </Paper>
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default PaymentMethodSelection; 
